import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkButton from '../shared/LinkButton';
import { TranslateRoutes } from '../shared/TranslateRoutes';
import { ArrowUpRight } from 'react-feather';

import { EventsDataUnit } from './types/EventsData';
import { EventDefault } from '../../assets/img/events';

import './event.css';

const translateRoutes = TranslateRoutes();

type EventsProps = {
    events: EventsDataUnit,
};

const Event = ({ events }: EventsProps): React.JSX.Element => {

    const { t } = useTranslation();

    return (
        <div className='event-card'>
            <div className='img-container'>
                <img
                    className='img'
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = EventDefault;
                    }}
                    src={events.eventImgBase64}
                    alt={t('Pages.Events.Image')}
                />
            </div>
            <div className='content-container'>
                <p className='title'>{events.title}</p>
                <div className="divider"></div>
                <p className='date'>{events.eventPeriod}</p>
                {events.location === "webinar" ?
                    <p className="location" dangerouslySetInnerHTML={{ __html: t('Pages.Events.Webinar')! }}></p>
                    : <p className="location">{events.location}</p>
                }
                <div className="btn-content">
                    <LinkButton to={`/${translateRoutes.events}/${events.eventId}`} className="flowly-btn blue">
                        {t("Pages.Events.SeeMore")} <ArrowUpRight size={16} />
                    </LinkButton>
                </div>
            </div>
        </div>
    );
};

export default Event;